import(/* webpackMode: "eager", webpackExports: ["EventoContent"] */ "/app/app/evento/evento-content.tsx");
